import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const TENANCY_TENANCY_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/tenancy',
        iconClass: 'fas fa-file-alt',
        name: 'AdministrationService::Menu:Tenancy',
        parentName: '::Menu:Settings',
        layout: eLayoutType.application,
        requiredPolicy: 'AdministrationService.Tenancy',
      },
    ]);
  };
}
